import BaseService from '@src/services/BaseService'

class PosCheckService extends BaseService {
    constructor() {
        super('pos-checks')
    }
}

export default new PosCheckService();